import { Badge } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { createColumnHelper } from "@tanstack/react-table";
import { formatDate } from './../../utils/formatDate'

export const getInfluencerBonusColumns = (setSelectedBonus, setModalOpen) => {
    const columnHelper = createColumnHelper();

    return [
        columnHelper.accessor("period", {
            header: "Periodo",
            cell: (info) => {
                const period = info.getValue();
                if (!period) return "—";
                // Extraer solo la parte de fecha sin conversión de zona horaria
                const start = period.start.split('T')[0].split('-').reverse().join('/');
                const end = period.end.split('T')[0].split('-').reverse().join('/');
                return `${start} - ${end}`;
            },
        }),
        columnHelper.accessor("calculation_date", {
            header: "Fecha cálculo",
            cell: (info) =>
                info.getValue() ? formatDate(info.getValue()) : "—",
        }),
        columnHelper.accessor("status", {
            header: "Estado",
            cell: (info) => {
                const status = info.getValue();
                const color =
                    status === "COMPLETED"
                        ? "success"
                        : status === "PENDING"
                            ? "warning"
                            : "secondary";
                return <Badge color={color}>{status}</Badge>;
            },
        }),
        columnHelper.display({
            id: "totales",
            header: "Totales por moneda",
            cell: (props) => {
                const totals = props.row.original.total_settlement_by_currency || {};
                const entries = Object.entries(totals);

                if (!entries.length) {
                    return <span className="text-muted">—</span>;
                }

                return (
                    <div>
                        {entries.map(([currency, val]) => (
                            <div key={currency}>
                                <strong>{currency}:</strong>{" "}
                                {Number(val.total_value).toLocaleString()}{" "}
                                <span className="text-muted">
                                    ({val.total_points} pts)
                                </span>
                            </div>
                        ))}
                    </div>
                );
            },
        }),
        columnHelper.display({
            id: "usersCount",
            header: "Usuarios",
            cell: (props) => props.row.original.users?.length ?? 0,
        }),
        columnHelper.display({
            id: "actions",
            header: "Acciones",
            cell: (props) => (
                <Btn
                    attrBtn={{
                        color: "info",
                        size: "sm",
                        id: `view-users-${props.row.original._id}`,
                        onClick: () => {
                            setSelectedBonus(props.row.original);
                            setModalOpen(true);
                        },
                    }}
                >
                    <i className="fa fa-eye"></i> Ver liquidaciones
                </Btn>
            ),
        }),
    ];
};
